import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";
import HeroGraphicOutgoings from "../../../assets/images/outgoings/outgoings-screenshot.png";
import HeroGraphicReminders from "../../../assets/images/outgoings/remainder_updated.png";
import SupportUserSection from "../../templates/SupportUserSection";
import UspSection from "../../templates/UspSection";
import PricingPlanCallToAction from "../../templates/PricingPlanCallToAction";
import PageCallToAction from "../PageCallToAction";
import sonCookingWithElderlyFather from "../../../assets/images/index/son-cooking-with-elderly-father.jpg";
import grandadGradeningWithGranddaughter from "../../../assets/images/index/grandad-gradening-with-granddaughter.jpg";
import grandadGradeningWithGranddaughternew from "../../../assets/images/index/couple-front-page.jpg";
import screenie1 from "../../../assets/images/index/screenshots/screenie-1.jpg";
import screenie2 from "../../../assets/images/index/screenshots/screenie-2.jpg";
import screenie3 from "../../../assets/images/index/screenshots/screenie-3.jpg";
import grandMotherAndGrandson from "../../../assets/images/index/grandmother-and-grandson.jpg";
import quoteZoneLogo from "../../../assets/images/third-party-logos/quote-zone-logo.png";
import giftCard1 from "../../../assets/images/gift-cards/life-style-gift-card.jpg";
import motSupportImg from "../../../assets/images/index/Homepage1.jpg";
import giftCard2 from "../../../assets/images/gift-cards/john-lewis-gift-card.jpg";
import giftCard3 from "../../../assets/images/gift-cards/river-island-gift-card.jpg";
import giftCard4 from "../../../assets/images/gift-cards/one4all-gift-card.jpg";
import giftCard5 from "../../../assets/images/gift-cards/boots-gift-card.jpg";
import giftCard6 from "../../../assets/images/gift-cards/m-and-s-gift-card.jpg";
import "../../../components/testimonialsSlider/TestimonialsSlider.scss";


const Home = () => {
  const [loading, setloading] = useState(true);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showIcon, setShowIcon] = useState(false);
  const videoRef = useRef(null);
  const iconTimeoutRef = useRef(null);

  const toggleMute = () => {
    if (videoRef.current && videoRef.current.contentWindow) {
      const nextMuted = !isMuted;
      videoRef.current.contentWindow.postMessage(
        JSON.stringify({ method: "setVolume", value: nextMuted ? 0 : 1 }),
        "*"
      );
      setIsMuted(nextMuted);
    }
  };

  const togglePlay = () => {
    if (videoRef.current && videoRef.current.contentWindow) {
      if (isPlaying) {
        videoRef.current.contentWindow.postMessage(
          JSON.stringify({ method: "pause" }),
          "*"
        );
        setIsPlaying(false);
      } else {
        videoRef.current.contentWindow.postMessage(
          JSON.stringify({ method: "play" }),
          "*"
        );
        setIsPlaying(true);
      }
      // Flash the centre icon
      setShowIcon(false);
      if (iconTimeoutRef.current) clearTimeout(iconTimeoutRef.current);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setShowIcon(true);
          iconTimeoutRef.current = setTimeout(() => setShowIcon(false), 700);
        });
      });
    }
  };


  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  // hello
  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "nedui962",
  };
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/nedui962'
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/nedui962";
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === "complete") {
        l();
      } else if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero pb-0" style={{ overflowX: "hidden" }}>
            <Container>
              {/* <Row className="justify-content-center">
                <Col xl="17">
                  <h1 className="text-center mb-4 mb-md-5">
                    Making life simple for the elderly and their families
                  </h1>
                </Col>
                <Col xl="14">
                  <p className="lead text-center mb-6 mb-md-7">
                    Manage your outgoings, save on bills, store warranties,
                    track vouchers and gift cards, set reminders, and discover
                    exclusive offers – all so you can focus on living!
                  </p>
                </Col>
              </Row> */}

              <Row className="justify-content-between align-items-center gx-xxl-5 gx-xl-4 mb-10 mb-lg-14 gy-5">
                {/* left side container  */}
                <Col xxl="10" xl="10" lg="24" className="mb-5 mb-lg-0">
                  <div
                    className="mb-4 fs-16 fw-bold text-uppercase tracking-wider"
                    style={{ color: "#36f1cc", letterSpacing: "0.1em" }}
                  >
                    Because No One Should Do This Alone​
                  </div>

                  <h1 className="mb-4 fw-bold lh-sm" style={{ fontSize: "clamp(2.2rem, 9vw, 3.75rem)" }}>
                    Stay Organised.<br className="d-none d-lg-block" />
                    {" "}Stay Independent.<br className="d-none d-lg-block" />
                    {" "}Stay Supported.
                  </h1>
                  <p className="lead mb-7 text-dark" style={{ lineHeight: "1.8" }}>
                    Helping families stay organised, connected and prepared, all in one place.
                  </p>
                  <div className="">
                    <Button href="/plans" size="lg" className="px-9 py-3 rounded-pill shadow-sm">
                      Get Support Now​
                    </Button>
                  </div>
                </Col>

                {/* right side video container */}
                <Col xxl="14" xl="14" lg="24" className="right-cont">
                  <div
                    style={{
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 20px 60px rgba(0, 58, 111, 0.18), 0 4px 16px rgba(54, 241, 204, 0.12)",
                      background: "#000",
                      position: "relative",
                      lineHeight: 0,
                    }}
                  >
                    <div style={{ position: "relative", paddingTop: "56.25%", height: 0, width: "100%" }}>
                      <iframe
                        ref={videoRef}
                        src="https://player.vimeo.com/video/1204543918?autoplay=1&loop=1&muted=0&controls=0&api=1"
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "block",
                        }}
                        title="Main Homepage video"
                      ></iframe>
                    </div>

                    {/* Clickable overlay for play/pause */}
                    <div
                      onClick={togglePlay}
                      style={{
                        position: "absolute",
                        inset: 0,
                        cursor: "pointer",
                        zIndex: 5,
                        borderRadius: "20px",
                      }}
                    />

                    {/* Centre flash icon (YouTube-style) */}
                    {showIcon && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          zIndex: 15,
                          pointerEvents: "none",
                          animation: "videoIconFade 0.7s ease forwards",
                        }}
                      >
                        <style>{`
                          @keyframes videoIconFade {
                            0%   { opacity: 1; transform: translate(-50%, -50%) scale(1); }
                            60%  { opacity: 0.9; transform: translate(-50%, -50%) scale(1.15); }
                            100% { opacity: 0; transform: translate(-50%, -50%) scale(1.3); }
                          }
                        `}</style>
                        <div style={{
                          width: "72px",
                          height: "72px",
                          borderRadius: "50%",
                          background: "rgba(0,0,0,0.55)",
                          backdropFilter: "blur(8px)",
                          WebkitBackdropFilter: "blur(8px)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}>
                          {isPlaying ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z"/>
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 24 24">
                              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                            </svg>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Mute / unmute button — always visible in corner */}
                    <button
                      onClick={e => { e.stopPropagation(); toggleMute(); }}
                      title={isMuted ? "Unmute" : "Mute"}
                      style={{
                        position: "absolute",
                        bottom: "16px",
                        right: "16px",
                        width: "44px",
                        height: "44px",
                        borderRadius: "50%",
                        border: "none",
                        cursor: "pointer",
                        background: "rgba(0, 0, 0, 0.55)",
                        backdropFilter: "blur(6px)",
                        WebkitBackdropFilter: "blur(6px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 20,
                        lineHeight: 1,
                        transition: "background 0.2s ease, transform 0.15s ease",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = "rgba(54,241,204,0.75)"; e.currentTarget.style.transform = "scale(1.1)"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "rgba(0,0,0,0.55)"; e.currentTarget.style.transform = "scale(1)"; }}
                    >
                      {isMuted ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24">
                          <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24">
                          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                        </svg>
                      )}
                    </button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          {/* ── Free MOT Section ─────────────────────────────────── */}
          <div className="mot-section">
            <Container>
              <Row className="align-items-center justify-content-between gy-5 gx-lg-5">

                {/* LEFT – text, bullets, CTA */}
                <Col xxl="10" xl="10" lg="24" className="mb-5 mb-lg-0">
                  <p
                    className="fw-bold text-uppercase mb-3"
                    style={{ color: "#36f1cc", fontSize: "0.8rem", letterSpacing: "0.12em" }}
                  >
                    Get Total Support with Elderly Life
                  </p>
                  <h2 className="fw-bold mb-3" style={{ fontSize: "clamp(1.6rem, 4vw, 2.4rem)", color: "#0b1f3a" }}>
                    Start Today &amp; Request Your{" "}
                    <span style={{ color: "#36f1cc" }}>Free MOT</span>
                  </h2>
                  <p className="mb-3" style={{ color: "#444", lineHeight: 1.7, fontWeight: "500" }}>
                    Once you join Elderly Life, you can request a free Elderly Life MOT.
                  </p>
                  <p className="mb-4" style={{ color: "#444", lineHeight: 1.7, fontWeight: "500" }}>
                    A member of our support team will contact you directly and send a booking link so you can choose a time that works best for you.
                  </p>

                  {/* Bullet list */}
                  {[
                    {
                      text: "A friendly support member will call you",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0b1f3a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 14c0-4.97 4.03-9 9-9s9 4.03 9 9" />
                          <rect x="2" y="12" width="3" height="5" rx="1" />
                          <rect x="19" y="12" width="3" height="5" rx="1" />
                          <path d="M19 17v1a3 3 0 0 1-3 3h-2" />
                        </svg>
                      )
                    },
                    {
                      text: "You'll receive a Calendly invite to pick a time",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0b1f3a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                      )
                    },
                    {
                      text: "We'll walk through your account together",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0b1f3a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="6" y="3" width="12" height="18" rx="2" />
                          <path d="M9 3V1h6v2" />
                          <line x1="10" y1="8" x2="14" y2="8" />
                          <line x1="10" y1="12" x2="14" y2="12" />
                          <line x1="10" y1="16" x2="14" y2="16" />
                        </svg>
                      )
                    },
                    {
                      text: "We'll help you add what matters most",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0b1f3a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      )
                    },
                    {
                      text: "A complete MOT checklist for peace of mind",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0b1f3a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                          <path d="M9 11l2 2 4-4" />
                        </svg>
                      )
                    }
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="d-flex align-items-center mb-2 pb-2"
                      style={{ borderBottom: "1px solid #eef0f3" }}
                    >
                      <span
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background: "#e2fdf8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          marginRight: 12,
                        }}
                      >
                        {item.icon}
                      </span>
                      <span style={{ fontSize: "0.95rem", color: "#333", fontWeight: "500" }}>{item.text}</span>
                    </div>
                  ))}

                  <Button
                    href="/plans"
                    size="lg"
                    className="mt-5 px-5 py-3 fw-bold"
                    style={{
                      background: "#36f1cc",
                      border: "none",
                      color: "#0b1f3a",
                      fontSize: "0.95rem",
                      borderRadius: "100px",
                    }}
                  >
                    Start Today &amp; Request Your Free MOT →
                  </Button>
                </Col>

                {/* right side – swiper-style: mint bg container, image inside with rounded corners */}
                <Col xxl="12" xl="12" lg="24" className="right-cont">
                  <div className="mot-right-card">
                    {/* Image — wider, fills full height */}
                    <div className="mot-image-wrapper">
                      <img
                        src={motSupportImg}
                        alt="Support specialist helping an elderly person with a laptop"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "center top",
                          display: "block",
                        }}
                      />
                    </div>

                    {/* Text panel */}
                    <div className="mot-text-wrapper">
                      <h2 className="fw-bold mb-3" style={{ fontSize: "clamp(1.4rem, 2.2vw, 1.85rem)", color: "#1f4a83ff", lineHeight: 1.3 }}>
                        We're here to help you get set up and stay organised.
                      </h2>
                      <p className="mb-3" style={{ color: "#4a5568", lineHeight: 1.6, fontSize: "0.92rem" }}>
                        Our free Elderly Life MOT is a personalised support call where we help you:
                      </p>
                      {[
                        "Get organised",
                        "Understand the platform",
                        "Add important information",
                        "Set up support users",
                        "Make sure nothing important gets missed",
                      ].map((item, i) => (
                        <div key={i} className="d-flex align-items-center mb-4">
                          {/* Dark mint circle with black tick */}
                          <span
                            style={{
                              width: 26,
                              height: 26,
                              borderRadius: "50%",
                              backgroundColor: "#00bfa5",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                              marginRight: 14,
                            }}
                          >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                              <path d="M20 6L9 17l-5-5" stroke="#000" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          <span style={{ fontSize: "0.92rem", color: "#0b1f3a", fontWeight: "500" }}>{item}</span>
                        </div>
                      ))}
                      <p className="mt-3 fw-bold" style={{ color: "#0b1f3a", fontSize: "0.92rem", lineHeight: 1.5 }}>
                        Because no one should have to manage everything alone.
                      </p>
                    </div>
                  </div>
                </Col>

              </Row>
            </Container>
          </div>
          {/* ── End Free MOT Section ─────────────────────────────── */}

          <Container>
            <section className="pb-9 pb-md-10 pb-xl-11 pb-xxxl-12">
              <Row className="justify-content-center mb-8 mb-md-10">
                <Col xl="20" xxxl="17">
                  <h2 className="text-center mb-4">
                    One place for everything that matters
                  </h2>
                  <p className="lead text-center mb-0">
                    Stay organised with reminders, finances, appointments and important information all in one place.
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center gy-5 gx-xxxl-6">
                <Col lg xl="8" xxl className="d-none d-lg-flex">
                  <Row className="gy-4">
                    <Col lg="24">
                      <div
                        className="p-7 rounded-4"
                        style={{
                          backgroundColor: "#e2fdf8",
                        }}
                      >
                        <Image
                          src={HeroGraphicReminders}
                          className="img-fluid rounded-4"
                          alt=""
                        />
                      </div>
                    </Col>
                    <Col lg="24">
                      <Image
                        src={sonCookingWithElderlyFather}
                        className="img-object-fit-cover rounded-4"
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg="auto" xl xxl="auto" xxxl="11" className="d-flex">
                  <div
                    className="p-7 rounded-4"
                    style={{ backgroundColor: "#e2fdf8" }}
                  >
                    <div className="bg-white h-100 rounded-4 d-flex align-items-center justify-content-center">
                      <Image
                        src={HeroGraphicOutgoings}
                        className="img-fluid d-lg-none d-xl-block d-xxl-none d-xxxl-block"
                        alt=""
                        style={{ objectFit: "contain" }}
                      />
                      <Image
                        src={HeroGraphicOutgoings}
                        width="600"
                        className="img-fluid d-none d-lg-block d-xl-none d-xxl-block d-xxxl-none"
                        alt=""
                        style={{ objectFit: "contain" }}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg="24" xxl className="d-xxxl-flex">
                  <Row className="gy-4">
                    <Col md xxl="24">
                      <Image
                        src={grandadGradeningWithGranddaughter}
                        className="img-object-fit-cover rounded-4 d-lg-none d-xxl-block"
                        alt=""
                      />
                      <div
                        className="d-none d-lg-block d-xl-none"
                        style={{ height: "287px" }}
                      >
                        <Image
                          src={grandadGradeningWithGranddaughter}
                          className="img-object-fit-cover rounded-4"
                          alt=""
                        />
                      </div>
                      <div
                        className="d-none d-xl-block d-xxl-none"
                        style={{ height: "327px" }}
                      >
                        <Image
                          src={grandadGradeningWithGranddaughter}
                          className="img-object-fit-cover rounded-4"
                          alt=""
                        />
                      </div>
                    </Col>

                    <Col md xxl="24">
                      <Image
                        src={grandadGradeningWithGranddaughternew}
                        className="img-object-fit-cover rounded-4 d-lg-none d-xxl-block"
                        alt=""
                        style={{ height: "330px" }}
                      />
                      <div
                        className="d-none d-lg-block d-xl-none"
                        style={{ height: "287px" }}
                      >
                        <Image
                          src={grandadGradeningWithGranddaughternew}
                          className="img-object-fit-cover rounded-4"
                          alt=""
                        />
                      </div>
                      <div
                        className="d-none d-xl-block d-xxl-none"
                        style={{ height: "327px" }}
                      >
                        <Image
                          src={grandadGradeningWithGranddaughternew}
                          className="img-object-fit-cover rounded-4"
                          alt=""
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </section>
            <section className="pt-8 pb-11 pt-md-9 pb-md-12 pt-xl-10 pb-xl-13 pt-xxxl-11 pb-xxxl-14">
              <Row className="justify-content-center mb-10 mb-md-11 mb-xl-12">
                <Col xl="20" xxxl="17">
                  <h2 className="text-center mb-5 mb-md-6">
                    Everything important, organised in one place.
                  </h2>
                  <p className="lead text-center mb-0">
                    From bills and reminders to warranties and appointments, Elderly Life helps families stay one step ahead.
                  </p>
                </Col>
              </Row>
              <Row className="row-cols-1 row-cols-md-2 row-cols-xl-4 justify-content-center gy-5 gx-xxxl-6">
                <Col>
                  <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xs="18" md="19" xl xxl="21" xxxl="18">
                        <h6 className="text-center mb-3">
                          Keep track of everyday outgoings
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Stay on top of bills, subscriptions and household costs in one place.
                        </p>
                      </Col>
                    </Row>
                    <Image
                      src={screenie1}
                      className="img-fluid rounded-3 shadow"
                      alt=""
                    />
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xs="18" xl xxl="21" xxxl="18">
                        <h6 className="text-center mb-3">
                          Stay Organised And Save Money
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Simple comparisons for household bills and renewals.
                        </p>
                      </Col>
                    </Row>
                    <Image
                      src={screenie2}
                      className="img-fluid rounded-3 shadow mb-3"
                      alt=""
                    />
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="small-xs fw-semibold text-center">
                        Powered by
                      </div>
                      <Image
                        src={quoteZoneLogo}
                        height="16"
                        className="ms-2"
                        alt=""
                      />
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xs="19" md="20" xl xxl="22" xxxl="19">
                        <h6 className="text-center mb-3">
                          Never miss an important moment
                        </h6>
                        <div className="d-flex justify-content-center">
                          <ul className="small text-dark mb-0 text-start" style={{ paddingLeft: "1.2rem", margin: 0 }}>
                            <li className="mb-1">Birthdays</li>
                            <li className="mb-1">Appointments</li>
                            <li className="mb-1">Renewals</li>
                            <li>Reminders</li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                    <div className="me-9">
                      <Image
                        src={screenie3}
                        className="img-fluid rounded-3 shadow"
                        alt=""
                      />
                    </div>
                    <div className="ms-9 mt-4">
                      <Image
                        src={grandMotherAndGrandson}
                        className="img-fluid rounded-3 shadow"
                        alt=""
                      />
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xs="19" md="20" xl xxl="23" xxxl="19">
                        <h6 className="text-center mb-3">
                          Keep track of gift cards and warranties
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Never let a gift card, voucher or warranty expire
                          again.
                        </p>
                      </Col>
                    </Row>
                    <Row className="justify-content-center gy-5 gx-xxxl-6 gy-xxxl-6">
                      <Col xs="auto">
                        <Image
                          src={giftCard1}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard2}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard3}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard4}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard5}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard6}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </section>
            <SupportUserSection />
            <UspSection />
          </Container>
          {/* <TestimonialsSlider /> */}
          <PricingPlanCallToAction />
          <PageCallToAction
            messageContent="Start today, for yourself or someone you care about."
            subtitle="Peace of mind starts with staying organised together."
          />
          <Footer />
        </>
      )}
    </>
  );
};

export default Home;